export const FETCH_EMERGENCY_BANNER = 'FETCH_EMERGENCY_BANNER';
export const SET_EMERGENCY_BANNER = 'SET_EMERGENCY_BANNER';
